import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import App from 'resizement/scripts/resize';

Snappy.Component.Scrollto = class Scrollto extends Snappy.BaseComponent {
    static get tagName() {
        return 'cfa-scrollto';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
        this.onResize();
    }

    setVars() {
        const name = this.$element.attr('data-name');
        this.$links =  $(document).find(`.js-scroll-link[data-target="${name}"]`);
        this.$desktopNav = $(document).find('.js-sticky-nav-container');
        this.$mobilenav = $(document).find('.cfa-nav-mobile');
    }

    setEventListeners() {
        $(window).on('resize:finished', this.bindedResize = this.onResize.bind(this));
        this.$links.on('click', this.scrollToTarget.bind(this));
    }

    scrollToTarget(e) {
        if(e.target.hasAttribute('data-push-state') && 'replaceState' in history) {
            history.replaceState({}, document.title, e.target.getAttribute('data-push-state') + location.hash);
            const evt = document.createEvent('UIEvents');
            evt.initUIEvent('popstate', true, false, window, 0);
            window.dispatchEvent(evt);
        }
        let topOffset = this.$element[0].getBoundingClientRect().top;
        let scrollVal = topOffset + $(window).scrollTop() - this.menuHeight;
        $("html, body").animate({ scrollTop: scrollVal }, 300);
    }

    onResize(e) {
        if (!this.$desktopNav.length || !this.$mobilenav.length) {
            this.menuHeight = 0;
            return;
        }

        if (App.isDesktop) {
            this.menuHeight = this.$desktopNav.height();
        } else {
            this.menuHeight = this.$mobilenav.height();
        };
    }
};



// WEBPACK FOOTER //
// ./components/scrollto/scripts/scrollto.js